import { gql } from "@apollo/client";

export default gql`
  mutation askAiUpdateRoutine(
    $id: UUID!
    $skillId: String
    $skillSlug: String
    $triggerType: String
    $triggerConfig: JSONString
    $name: String
    $enabled: Boolean
  ) {
    updateRoutine(
      id: $id
      skillId: $skillId
      skillSlug: $skillSlug
      triggerType: $triggerType
      triggerConfig: $triggerConfig
      name: $name
      enabled: $enabled
    ) {
      routine {
        id
        name
        skillId
        skillSlug
        enabled
        triggerType
        triggerConfig
        skillExists
        selectedMeetingGroups {
          id
          title
        }
      }
    }
  }
`;
